/**
 * Top-right HUD cluster — score, kill count, gold earned this run.
 * Props: score, kills, goldThisRun
 */
export function StatsHUD({ score, kills, goldThisRun }) {
  return (
    <div className="hud-top-right">
      <span className="hud-stat">🛤️ {score.toLocaleString()} pts</span>
      <span className="hud-stat">⚔️ {kills ?? 0}</span>
      <span className="hud-stat hud-gold">💰 {goldThisRun ?? 0}</span>
    </div>
  );
}
